import { IconDefinition } from "./types";

const eye: IconDefinition = {
  iconName: "eye",
  width: 576,
  height: 512,
  svgPathData:
    "M52.5 256c15.1 30.9 41 71.2 76.6 105.4 42.6 41 95.8 70.6 158.9 70.6s116.2-29.5 158.9-70.6c35.6-34.3 61.5-74.5 76.6-105.4-15.1-30.9-41-71.2-76.6-105.4-42.6-41-95.8-70.6-158.9-70.6s-116.2 29.5-158.9 70.6C93.6 184.8 67.7 225.1 52.5 256zM576 256c-30 74.7-129.6 224-288 224S30 330.7 0 256C30 181.3 129.6 32 288 32S546 181.3 576 256zM288 336c44.2 0 80-35.8 80-80 0-32.8-19.7-61-48-73.3l0 105.3-105.3 0c12.3 28.3 40.5 48 73.3 48zm-78.4-96l62.4 0 0-62.4c-31.3 6.4-56 31.1-62.4 62.4zM288 128a128 128 0 1 1 0 256 128 128 0 1 1 0-256z",
  iconType: "fill",
  fill: "none",
  fontAwesomeName: "eye",
  unicode: 0xf06e,
};

export { eye };
